export enum ApiTag {
	Chat = 'Chat',
	ChatMessage = 'ChatMessage',
	Patient = 'Patient',
	VideoCallAppointment = 'VideoCallAppointment',
	PatientOverview = 'PatientOverview',
	ScheduledMessage = 'ScheduledMessage',
}
